import React from 'react';
import PropTypes from 'prop-types';
import { Groups,  } from '@mui/icons-material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import clsx from 'clsx';

const SubCategoryPill = ({ name, icon: Icon, isActive, onClick, groupId, onViewAccess }) => {
    const handleViewAccess = (e) => {
        e.stopPropagation();
        onViewAccess(groupId, name);
    };

    return (
        <div
            className={clsx(
                'flex items-center gap-2 px-4 py-2 rounded-full border transition-all cursor-pointer relative group',
                isActive
                    ? 'bg-blue-50 border-blue-200 text-blue-700 dark:bg-blue-900/20 dark:border-blue-800 dark:text-blue-400'
                    : 'bg-gray-50 border-gray-200 text-gray-700 hover:border-blue-200 hover:text-blue-600 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300'
            )}
            onClick={onClick}
        >
            {Icon && <Icon fontSize="small" className="text-current" />}
            <span className="font-medium">{name}</span>
            <button
                onClick={handleViewAccess}
                className="ml-2 p-1 rounded-full hover:bg-blue-100 dark:hover:bg-blue-800 transition-colors"
                title="Ver usuários com acesso"
            >
                <RemoveRedEyeIcon fontSize="small" />
            </button>
        </div>
    );
};

SubCategoryPill.propTypes = {
    name: PropTypes.string.isRequired,
    icon: PropTypes.elementType,
    isActive: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onViewAccess: PropTypes.func.isRequired,
};

export default React.memo(SubCategoryPill);
